import React, { Component } from "react";
import { PropTypes } from "prop-types";
import { NavLink } from "react-router-dom";
import {
  EditableText,
  TextInput,
  View,
} from "@zendesk/self-service-components";
import { Tag } from "@zendeskgarden/react-tags";
import t from "@zendesk/client-i18n-tools";
import { STAFF, SIGNED_IN_USERS, USER_TYPE_NAME } from "../../../../constants";
import { getUserSegmentsUrl } from "utils/urls";
import styles from "./index.css";

export default class Title extends Component {
  constructor(props) {
    super(props);

    this.onChange = this.onChange.bind(this);
  }

  onChange(value) {
    const { onChange } = this.props;

    if (value.length === 0) {
      return false;
    }

    onChange(value);
  }

  render() {
    const { name, userType, builtIn, actionButton } = this.props;

    if (builtIn) {
      return (
        <div className={styles.header}>
          <div>
            <div className={styles.builtInTitleContainer}>
              <div className={styles.back}>
                <NavLink to={getUserSegmentsUrl()} data-test-id="back-button">
                  {t("knowledge-user-segments.userSegment.back")}
                </NavLink>
              </div>
              <h1 className={styles.title}>{name}</h1>

              <Tag
                className={styles.builtInLabel}
                type="blue"
                data-test-id="built-in-label"
              >
                {t("knowledge-user-segments.userSegment.builtIn")}
              </Tag>

              <Tag
                className={styles.builtInLabel}
                type="blue"
                data-test-id="user-type-label"
              >
                {t(USER_TYPE_NAME[userType])}
              </Tag>
            </div>
          </div>
        </div>
      );
    }

    return (
      <div className={styles.header}>
        <div className={styles.back}>
          <NavLink to={getUserSegmentsUrl()} data-test-id="back-button">
            {t("knowledge-user-segments.userSegment.back")}
          </NavLink>
        </div>
        <div className={styles.titleWrapper}>
          <EditableText
            dir={t.dir}
            value={name}
            onChange={this.onChange}
            testId="edit-name"
            valueRenderer={({ containerProps, value }) => (
              <View
                {...containerProps}
                title={t("knowledge-user-segments.userSegment.editName")}
                aria-label={t(
                  "knowledge-user-segments.userSegment.nameFieldAriaLabel"
                )}
              >
                <h1 className={styles.title}>{value}</h1>
                <EditableText.Icon className={styles.icon} />
                <Tag
                  className={styles.builtInLabel}
                  type="blue"
                  data-test-id="user-type-label"
                >
                  {t(USER_TYPE_NAME[userType])}
                </Tag>
              </View>
            )}
            inputRenderer={({ inputProps, inputProps: { value } }) => (
              <TextInput
                {...inputProps}
                testId="edit-name-input"
                validation={inputProps.value.length === 0 ? "error" : null}
                validationText={t(
                  "knowledge-user-segments.userSegment.nameEmptyValidationError"
                )}
              />
            )}
          />
        </div>

        <div className={styles.actionContainer}>{actionButton}</div>
      </div>
    );
  }
}

Title.defaultProps = {
  name: "",
  builtIn: false,
  actionButton: null,
};

Title.propTypes = {
  name: PropTypes.string,
  userType: PropTypes.oneOf([STAFF, SIGNED_IN_USERS]),
  builtIn: PropTypes.bool.isRequired,
  onChange: PropTypes.func,
  actionButton: PropTypes.node,
};



// WEBPACK FOOTER //
// ./src/components/UserSegment/components/Title/index.js